import React from "react";
import Icons from "../../../../config/images";
import "./chooseSection.css";

const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className="why-choose-us-main-feature-card">
      <img src={icon} className="why-choose-us-inside-icon-style" alt="icon" />
      <div className="why-choose-us-inside-title-parent-container">
        <p className="why-choose-us-inside-title-style">{title}</p>
        <p className="why-choose-us-inside-description-style">{description}</p>
      </div>
    </div>
  );
};

const WhyChooseUsSection = () => {
  return (
    <div className="why-choose-us-main-container-style">
      <div className="heading-container">
        <span className="green-line"></span>
        <h4 className="why-choose-us-main-title-style">What We're Offering</h4>
      </div>
      <h2 className="why-choose-us-main-heading-style">
        Why You Should Choose Our Services
      </h2>
      <div className="why-choose-us-main-features-container-style">
        <FeatureCard
          icon={Icons.expertiseIcon}
          title="Industry Expertise"
          description="With lots of unique blocks, you can easily build a page without coding. Build your next landing page.."
        />
        <FeatureCard
          icon={Icons.clientIcon}
          title="Client-Centered Approach"
          description="We put your needs first."
        />
        <FeatureCard
          icon={Icons.scalableIcon}
          title="Scalable Solutions"
          description="Grow your business with us."
        />
        <FeatureCard
          icon={Icons.deadlineIcon}
          title="Never Miss Deadline"
          description="We ensure timely delivery."
        />
      </div>
    </div>
  );
};

export default WhyChooseUsSection;
